import { authFetch } from './api.js';

async function request(url, options) {
  const response = await authFetch(url, options);
  const json = await response.json();
  if (!response.ok || !json.success) throw new Error(json.error || '请求失败');
  return json.data;
}

export const apiGet = (url) => request(url);
export const apiPost = (url, body) => request(url, { method: 'POST', body: body ? JSON.stringify(body) : undefined });
export const apiPut = (url, body) => request(url, { method: 'PUT', body: body ? JSON.stringify(body) : undefined });
